import GridLine from "../../../../../../../components/layouts/grid-line-layout/grid-line/grid-line";
import GridLineItem from "../../../../../../../components/layouts/grid-line-layout/grid-line/grid-line-item/grid-line-item";
import FontBody1 from "../../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import FontBody3 from "../../../../../../../components/fonts/font-body3/font-body3";
import MissingShipmentValue from "../missing-shipment-value/missing-shipment-value";
import ShipmentStatusChip from "../shipment-status-chip/shipment-status-chip";
import LabelOrSlipsCell from "../label-or-slips-cell/label-or-slips-cell";
import RmaShipmentStore from "../../../../stores/rma-shipment-store";
import RmaPageStore from "../../../../stores/rma-page-store";
import SlipsCell from "../slips-cell/slips-cell";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IDropOffLocationGridProps {
    isStatusDisplayed: boolean;
    location?: string | null;
    shipment: RmaShipmentStore;
    rmaPageStore: RmaPageStore;
}

const DropOffLocationGridWithoutIntegration: React.FC<IDropOffLocationGridProps> = ({ isStatusDisplayed, location, shipment, rmaPageStore }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';

    return (
        <GridLine
            settings={{
                columns: [{ width: 3 }, { width: 2 }, { width: 2 }, { width: 2 }, { width: 2}, { width: 5 }]
            }}
            columns={[
                <GridLineItem>
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{shipment.returnMethodName}</FontBody1>
                </GridLineItem>,
                <GridLineItem>
                    <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{getTranslation('SHIPMENT_COLUMN_TITLE_FOR_LOCATION', pageScope)}</FontBody3>
                    <FontBody3 color={FONT_COLOR.PRIMARY3_50}>{location}</FontBody3>
                </GridLineItem>,
                <GridLineItem>
                    <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{getTranslation('SHIPMENT_COLUMN_TITLE_FOR_ITEMS', pageScope)}</FontBody3>
                    <FontBody3 color={FONT_COLOR.PRIMARY3_50}>{shipment.numberOfItems}</FontBody3>
                </GridLineItem>,
                <GridLineItem>
                    <LabelOrSlipsCell content={shipment.labelContent()} rmaPageStore={rmaPageStore} />
                </GridLineItem>,
                <GridLineItem>
                    <SlipsCell shipment={shipment} rmaPageStore={rmaPageStore} />
                </GridLineItem>,
                <GridLineItem>
                    {isStatusDisplayed ? (
                        <FontBody3 color={FONT_COLOR.PRIMARY3_50}>
                            {shipment.status
                                ? <ShipmentStatusChip status={shipment.status} statusCode={shipment.statusCode} />
                                : <MissingShipmentValue rmaPageStore={rmaPageStore} />
                            }
                        </FontBody3>
                    ) : <div></div>}
                </GridLineItem>
            ]} />
    );
};

export default DropOffLocationGridWithoutIntegration;